




































































import { Vue, Component } from "../vue-ext";
import { HousingCompany, Account, Message, Material, RoleEnum } from "../models";
import "../components/MaterialList";

@Component
export default class WelcomeView extends Vue {
    private account: Account | null = null;
    private housingCompany: HousingCompany | null = null;
    private messages: Message[] | null = null;
    private materials: Material[] | null = null;
    private emergencyPlanLink: string | null = null;
    RoleEnum = RoleEnum;

    public async created() {
        this.root.setTitle(this.$t("menu.home") as string);
        this.root.setIconClass("icon-home");

        this.account = this.root.getCurrentAccount();
        this.housingCompany = this.root.getCurrentHousingCompany();

        this.messages = (await this.root.updateMessages()).slice(0, 3);
        
        this.materials = (await this.root.updateMaterials()).slice(0, 3);

        if (this.housingCompany) {
            this.emergencyPlanLink = await this.root.service.housingCompany.GetEmergencyPlanLink(this.housingCompany.housingCompanyId);
        }
    }
}
